import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/performance';
import 'firebase/analytics';

// firebase init goes here
const config = {
  apiKey: "AIzaSyAaZ8gSO51K30zdY5v1kXndlWuXuMDT6IM",
  authDomain: "auth.bing8.dtslabs.com",
  databaseURL: "https://dts-bing8.firebaseio.com",
  projectId: "dts-bing8",
  storageBucket: "dts-bing8.appspot.com",
  messagingSenderId: "177811753476",
  appId: "1:177811753476:web:465637e889fffb91950351",
  measurementId: "G-JEHGN4L6DB"
}
firebase.initializeApp(config);
firebase.analytics();
const perf = firebase.performance();

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth;

// firebase collections
const usersCollection = db.collection('users');
const roomsCollection = db.collection('rooms');
const seriesCollection = db.collection('series');
const ticketsCollection = db.collection('tickets');
const gamesCollection = db.collection('games');

export {
  db,
  auth,
  perf,
  usersCollection,
  roomsCollection,
  seriesCollection,
  ticketsCollection,
  gamesCollection,
}